import { ModuleWrapper } from '@/components'
import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import { LearningFolder } from '../components/learning-folder'
import { GENERAL_FOLDER_KEY } from '../consts'
import { useStorylaneScript } from '../hooks'
import { LEARNING_FOLDERS_QUERY } from '../queries'

export function Learning() {
  const translations = useTranslate({
    title: 'learning.title',
    empty: 'learning.empty',
  })

  const { data, loading } = useQuery(LEARNING_FOLDERS_QUERY)

  useStorylaneScript()

  const folders = data?.learningFolders ?? []

  return (
    <ModuleWrapper title={translations.title} loading={loading}>
      {folders.length === 0 ? (
        !loading && (
          <p className="rounded-2xl bg-white px-5 py-4 text-sm text-stone-600 shadow-card">
            {translations.empty}
          </p>
        )
      ) : (
        <div className="space-y-4">
          {folders.map(folder => (
            <LearningFolder
              key={folder.module ?? GENERAL_FOLDER_KEY}
              folder={folder}
            />
          ))}
        </div>
      )}
    </ModuleWrapper>
  )
}
